import { apiService, type PagingApiAndNotifierConfig } from "@modernary/mui/utils/api";
import { serializeQueryParams } from "@modernary/mui/utils/helpers";
import { NotifyOptionsSuccess, type NotifyOptionsError } from "@modernary/mui/components/notifications";
import { apiHosts } from "@/api/constants/apiHosts";

import type { DustMonitorClass, DustMonitorClassQuery } from "./dustMonitorClass";
import { convertDateStringToUseMonthaAbbreviations } from "@/docGen/helpers";
import { fromDateAndTimeToFormat, sysDate } from "@modernary/mui/utils/filters";

const URL = "dust-monitor-classes";
const ENTITY_NAME = "Dust Monitor Class";

const axiosParams = {
  // Set different base URL based on the environment
  baseURL: import.meta.env.VITE_AQMS_API_BASE_URL,
};
const api = apiService<DustMonitorClass>(apiHosts.AQMS, axiosParams);

const getDustMonitorClasses = (params: DustMonitorClassQuery, config: PagingApiAndNotifierConfig = {}) => {
  const successNotifCb = (options: NotifyOptionsSuccess) => {
    options.hide = true;
    config?.successNotifCb?.(options);
  };
  const errorNotifCb = (options: NotifyOptionsError) => {
    options.fetched = ENTITY_NAME;
    config?.errorNotifCb?.(options);
  };

  const url = config.pagingUrl ? config.pagingUrl : URL;

  return api.getPaged(url, {
    params,
    paramsSerializer: serializeQueryParams,
    abort: config?.abortMethod,
    successNotifCb,
    errorNotifCb,
  });
};

const getDustMonitorClassById = (id: string | number, config: PagingApiAndNotifierConfig = {}) => {
  const successNotifCb = (options: NotifyOptionsSuccess) => {
    options.hide = true;
    config?.successNotifCb?.(options);
  };
  const errorNotifCb = (options: NotifyOptionsError) => {
    options.fetched = ENTITY_NAME;
    config?.errorNotifCb?.(options);
  };

  return api.get(URL + "/" + id, {
    successNotifCb,
    errorNotifCb,
  });
};

function getDustMonitorClassDisplayDate(dmc: DustMonitorClass) {
  if (dmc.classLocalDate == null || dmc.classLocalTime == null) return null;

  const submittedDateTimeDisplay = sysDate.shortDateString(dmc.classLocalDate);

  if (!submittedDateTimeDisplay) return undefined;

  const submittedDateTimeSlicedString = submittedDateTimeDisplay.split("/");
  const submittedYear = parseInt(submittedDateTimeSlicedString[2]);
  const submittedMonth = parseInt(submittedDateTimeSlicedString[0]);
  const submittedDay = parseInt(submittedDateTimeSlicedString[1]);

  const prevDay = new Date(submittedYear, submittedMonth - 1, submittedDay - 1);
  var classLocDateLongString = `${sysDate.longDateString(dmc.classLocalDate) ?? ""}`;
  var shortedclassLocDateLongString = convertDateStringToUseMonthaAbbreviations(classLocDateLongString);

  const firstDayDisplay = prevDay.toDateString().slice(4, -5);

  const classLocDateDisplay =
    prevDay.getMonth() == submittedMonth - 1 ? shortedclassLocDateLongString?.slice(3) : shortedclassLocDateLongString;

  var result = `${firstDayDisplay} & ${classLocDateDisplay} ${fromDateAndTimeToFormat(null, dmc.classLocalTime) ?? ""}`;

  return result;
}

export { getDustMonitorClasses, getDustMonitorClassById, getDustMonitorClassDisplayDate };
